import { csParamKey, csUsageParamKey, invoiceItemParamKey, logParamKey } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export enum ServiceRouteName {
    Index = 'company-services.index',
    Create = 'company-services.create',
    Edit = 'company-services.edit',
    Clone = 'company-services.clone',
    EditRate = 'company-services.edit-rate',
    Usage = 'company-services.usage',
    UsageDetails = 'company-services.usage.details',
    UsageTariff = 'company-services.usage.tariff',
    UsageProvider = 'company-services.usage.provider',
    Invoices = 'company-services.invoices',
    InvoiceEdit = 'company-services.invoices.edit',
    InvoiceLogs = 'company-services.invoices.logs',
    InvoiceLogDetails = 'company-services.invoices.logs.details',
    Details = 'company-services.details',
    Logs = 'company-services.logs',
    LogDetails = 'company-services.logs.details',
}

export default {
    path: 'services',
    name: ServiceRouteName.Index,
    component: () => import('@/views/company-services/Index.vue'),
    meta: {
        label: 'Services',
        auth: true,
        permission: Permission.CompanyServiceViewAny,
    },
    children: [
        {
            path: 'create',
            name: ServiceRouteName.Create,
            component: () => import('@/views/company-services/Index.vue'),
            meta: {
                label: 'Create Service',
                auth: true,
                permission: Permission.CompanyServiceCreate,
            },
        },
        {
            path: `:${csParamKey}/edit`,
            name: ServiceRouteName.Edit,
            component: () => import('@/views/company-services/Index.vue'),
            meta: {
                label: 'Edit Service',
                auth: true,
                permission: Permission.CompanyServiceUpdate,
            },
        },
        {
            path: `:${csParamKey}/clone`,
            name: ServiceRouteName.Clone,
            component: () => import('@/views/company-services/Index.vue'),
            meta: {
                label: 'Clone Service',
                auth: true,
                permission: Permission.CompanyServiceCreate,
            },
        },
        {
            path: `:${csParamKey}/edit-rate`,
            name: ServiceRouteName.EditRate,
            component: () => import('@/views/company-services/Index.vue'),
            meta: {
                label: 'Edit Rate',
                auth: true,
                permission: Permission.CompanyServiceUpdate,
            },
        },
        {
            path: `:${csParamKey}/usage`,
            name: ServiceRouteName.Usage,
            component: () => import('@/views/company-services/Index.vue'),
            meta: {
                label: 'Usage',
                auth: true,
                permission: Permission.CompanyServiceUsageViewAny,
            },
            children: [
                {
                    path: `:${csUsageParamKey}/details`,
                    name: ServiceRouteName.UsageDetails,
                    component: () => import('@/views/company-services/Index.vue'),
                    meta: {
                        label: 'Usage Details',
                        auth: true,
                        permission: Permission.CompanyServiceUsageView,
                    },
                },
                {
                    path: `:${csUsageParamKey}/tariff`,
                    name: ServiceRouteName.UsageTariff,
                    component: () => import('@/views/company-services/Index.vue'),
                    meta: {
                        label: 'Usage Tariff',
                        auth: true,
                        permission: Permission.TariffView,
                    },
                },
                {
                    path: `:${csUsageParamKey}/provider`,
                    name: ServiceRouteName.UsageProvider,
                    component: () => import('@/views/company-services/Index.vue'),
                    meta: {
                        label: 'Usage Provider',
                        auth: true,
                        permission: Permission.ModuleView,
                    },
                },
            ],
        },
        {
            path: `:${csParamKey}/invoices`,
            name: ServiceRouteName.Invoices,
            component: () => import('@/views/company-services/Index.vue'),
            meta: {
                label: 'Invoices',
                auth: true,
                permission: Permission.CompanyServiceView,
            },
            children: [
                {
                    path: `:${invoiceItemParamKey}/edit`,
                    name: ServiceRouteName.InvoiceEdit,
                    component: () => import('@/views/company-services/Index.vue'),
                    meta: {
                        label: 'Invoice Edit',
                        auth: true,
                        permission: Permission.InvoiceItemUpdate,
                    },
                },
                {
                    path: `:${invoiceItemParamKey}/logs`,
                    name: ServiceRouteName.InvoiceLogs,
                    component: () => import('@/views/company-services/Index.vue'),
                    meta: {
                        label: 'Invoice Logs',
                        auth: true,
                        permission: Permission.InvoiceItemView,
                    },
                    children: [
                        {
                            path: `:${invoiceItemParamKey}/details`,
                            name: ServiceRouteName.InvoiceLogDetails,
                            component: () => import('@/views/company-services/Index.vue'),
                            meta: {
                                label: 'Log Details',
                                auth: true,
                                permission: Permission.EventView,
                            },
                            children: [],
                        },
                    ],
                },
            ],
        },
        {
            path: `:${csParamKey}/details`,
            name: ServiceRouteName.Details,
            component: () => import('@/views/company-services/Index.vue'),
            meta: {
                label: 'Service Details',
                auth: true,
                permission: Permission.CompanyServiceView,
            },
        },
        {
            path: `:${csParamKey}/logs`,
            name: ServiceRouteName.Logs,
            component: () => import('@/views/company-services/Index.vue'),
            meta: {
                label: 'Service Logs',
                auth: true,
                permission: Permission.CompanyServiceView,
            },
            children: [
                {
                    path: `:${logParamKey}/details`,
                    name: ServiceRouteName.LogDetails,
                    component: () => import('@/views/company-services/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                    children: [],
                },
            ],
        },
    ],
}
